import { createContext, useContextSelector } from 'use-context-selector';

const GlobalStateCS = createContext(null);
const useGlobalStateSelector = (selector) => useContextSelector(GlobalStateCS, selector);

const words = require('./words.json');
const periods = ['lifetime', 'monthly'];
const gameModes = ['human', 'computer'];
const difficultyModes = ['simple', 'advanced'];
const collectibleWordTextKeys = ['liveText', 'field', 'straightManText'];

const stateKeysToSetAddress = [
  ['active', 'addressMain'],
  ['configure', 'addressMain'],
  ['getPointHistory', 'addressMain'],
  ['getItemOrderHistory', 'addressMain'],
  ['makeUrlToBroadcast', 'addressMain'],
  ['unregisteredAddress', 'address'],
  ['checkout', 'addressMain'],
];

const stateKeysToSetUserName = [
  ['configure', 'userName'],
];

function getInitialConfigureState(addressMain = '') {
  return {
    addressMain,
    displayAddressSection: false,
    userName: '',
    readTheTermsAndConditions: false,
    readPrivacyPolicy: false,
    acceptedVersionOfTheTermsAndConditions: null,
    acceptedVersionOfPrivacyPolicy: null,
    mnemonic: null,
    status: null,
  };
}

export {
  GlobalStateCS,
  useGlobalStateSelector,
  words,
  periods,
  gameModes,
  difficultyModes,
  collectibleWordTextKeys,
  getInitialConfigureState,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
};
